import { z } from "zod";

export const bidResponseSchema = z.object({
  id: z.uuid().optional(),
  reference: z.string().optional(),
  title: z.string().min(1, "Title is required"),
  section: z.string().optional(),
  description: z.string().optional(),
  assigneeId: z.uuid().nullable().optional(),
  reviewerId: z.uuid().nullable().optional(),
  weighting: z.string().optional(),
  formattingRequirements: z.string().optional(),
  // Nullable matters here: DateInput's clear button emits null, and z.coerce.date()
  // would turn that into new Date(null) — the epoch — rather than failing validation.
  dueDate: z.coerce
    .date()
    .transform((date) => date.toISOString())
    .nullable()
    .optional(),
  bidId: z.uuid(),
  stageId: z.uuid(),
});

export type BidResponseFormInput = z.input<typeof bidResponseSchema>;
export type BidResponseFormOutput = z.output<typeof bidResponseSchema>;
